import * as tslib_1 from "tslib";
import { LayerApi } from '../api/layer-api';
import { SearchApi } from '../api/search-api';
import { AssetIdColumnMap, AssetIdTypes } from '../keys';
import { LogLevel } from '../types';
import { AoiService } from './aoi.service';
import { DeepLinkProcessor } from './deep-link-processor.service';
import { GisToolsService } from './gis-tools.service';
import { MapService } from './map.service';
import { QueryStringParamService } from './query-string-param-service';
import * as i0 from "@angular/core";
import * as i1 from "./deep-link-processor.service";
import * as i2 from "./map.service";
import * as i3 from "./aoi.service";
import * as i4 from "./gis-tools.service";
import * as i5 from "./query-string-param-service";
import * as i6 from "../api/search-api";
import * as i7 from "../api/layer-api";
var DeepLinkService = /** @class */ (function () {
    function DeepLinkService(authService, deepLinkProcessor, mapService, AOIService, gisToolsService, queryStringParamService, searchApi, layerApi) {
        var _this = this;
        this.authService = authService;
        this.deepLinkProcessor = deepLinkProcessor;
        this.mapService = mapService;
        this.AOIService = AOIService;
        this.gisToolsService = gisToolsService;
        this.queryStringParamService = queryStringParamService;
        this.searchApi = searchApi;
        this.layerApi = layerApi;
        this.parameters = {
            //showGrid: 'showGrid',
            //mpmsProjectId: ['mpms', 'mpmsNumber', 'proj', 'projectId'],
            //tmsSiteNumber: ['tmsSiteNumber', 'tmsSiteNo', 'tms'],
            //tmsPermanentSiteId: ['tmsPermanentSiteId'],
            //petlProjectId: ['petl', 'petl-project-id', 'petlProjectId'],
            //petlProjectDescription: ['petl-project-description'],
            layerId: ['layer-Id', 'layerId'],
            column: ['column', 'columnName'],
            value: ['value'],
            //program: 'program',
            //programStatus: 'programStatus',
            mapId: ['map-id', 'mapId'],
            counties: ['counties', 'countyNumbers'],
            countyNumber: ['ct', 'cn', 'cty', 'cty-code', 'county', 'countyNumber'],
            routeNumber: ['rt', 'route', 'st-rt-no', 'routeNumber'],
            segmentNumber: ['sg', 'seg', 'segment', 'segmentNumber'],
            latitude: ['lat', 'latitude'],
            longitude: ['long', 'longitude'],
            query: ['query'],
            bridgeKey: ['brkey', 'br-key', 'bridge-key'],
            bridgeId: ['bridge-id', 'bridgeid'],
            hopNumber: ['HOPNumber', 'hopNumber', 'hop'],
            hopApplicationId: ['HOPApplicationNumber', 'hopApplicationId'],
            districtNumber: ['district', 'dist', 'districtNumber'],
            projectId: ['projectId', 'projectIds'],
            brkey: ['bridgeKeys', 'brkeys', 'brKey'],
            hopPermitNumber: 'hopNumbers',
            hbmsPermitNumber: ['hbmsPermitNumber'],
            billboardId: ['billboardId'],
            junkyardId: ['junkyardId'],
            countyMunicipalityCode: ['countyMunicipalityCode'],
            municipalityId: ['muni', 'municipalityId'],
            municipalCode: ['municipalCode', 'municipalityCode'],
            corridorRt: ['corr_rt', 'corridorRouteNumber'],
            segmentNumberBegin: ['sg', 'segmentBegin', 'segmentNumberBegin', 'beginSegment', 'beginSegmentNumber', 'segment', 'segmentNumber'],
            segmentNumberEnd: ['sgend', 'segmentEnd', 'segmentNumberEnd', 'endSegment', 'endSegmentNumber'],
            mpoRpo: ['mporpo', 'planningPartnerShortname'],
            legislativeType: ['legtype', 'legislativeType'],
            legislativeDistrict: ['legdist', 'legislativeDistrict', 'legislativeDistrictNumber'],
            congressDistrictNumber: ['congressDistrictNumber'],
            houseDistrictNumber: ['houseDistrictNumber'],
            senateDistrictNumber: ['senateDistrictNumber'],
            address: ['address'],
            crossingId: ['crossing', 'crossingId', 'crossing-id', 'crossingIds', 'crossing-ids'],
            streetView: ['streetView', 'street-view', 'showStreetView', 'show-street-view', 'openStreetView', 'open-street-view']
        };
        this.isUserLoggedIn = false;
        this.authService.permissions.subscribe(function (permissions) { return _this.userPermissions = permissions; });
        this.authService.user.subscribe(function (user) { return _this.isUserLoggedIn = user != null; });
    }
    DeepLinkService.prototype.registerDeepLinkProcessors = function () {
        var _this = this;
        //commented out items are not used in onemap, but may need to be configured for other apps
        this.deepLinkProcessor.registerHandler(this.parameters, function (params) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var currentSearchCriterias, searchCriterias, assetIdSearchCriteria, criteria;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.AOIService.setSearchCriterias([]);
                        currentSearchCriterias = this.AOIService.getSearchCriterias();
                        return [4 /*yield*/, this.getSearchCriterias(currentSearchCriterias, params)];
                    case 1:
                        searchCriterias = _a.sent();
                        assetIdSearchCriteria = this.getAssetIdSearchCriteria(params);
                        if (!assetIdSearchCriteria) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.formatAssetIdCriteria(assetIdSearchCriteria)];
                    case 2:
                        criteria = _a.sent();
                        searchCriterias.push(criteria);
                        _a.label = 3;
                    case 3:
                        if (!searchCriterias.length) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.showBySearchCriterias(searchCriterias, params)];
                    case 4:
                        _a.sent();
                        if (params.streetView && (params.streetView === 'true' || params.streetView === 'yes' || params.streetView === '1')) {
                            this.AOIService.openStreetView(params);
                        }
                        return [3 /*break*/, 7];
                    case 5:
                        if (!(params.mapId !== undefined && /^[0-9]{1,}$/.test(params.mapId))) return [3 /*break*/, 7];
                        return [4 /*yield*/, this.openMap(params)];
                    case 6:
                        _a.sent();
                        _a.label = 7;
                    case 7: return [2 /*return*/];
                }
            });
        }); });
    };
    // Returns true if at least one of the deep link parameters is present in the query string.
    DeepLinkService.prototype.deepLinkParamIsPresent = function (parameterKey) {
        var _this = this;
        if (parameterKey === void 0) { parameterKey = null; }
        var result = false;
        var queryStringParams = this.queryStringParamService.getQueryStringParams();
        var queryStringParamKeys = Object.keys(queryStringParams).map(function (p) { return p.toLowerCase(); });
        if (queryStringParamKeys.length > 0) {
            var parameterKeys = Object.keys(this.parameters);
            if (parameterKey) {
                parameterKeys = parameterKeys.filter(function (k) { return k === parameterKey; });
            }
            result = parameterKeys.map(function (key) { return [_this.parameters[key]].flat(); }).flat().some(function (key) { return queryStringParamKeys.includes(key.toLowerCase()); });
        }
        return result;
    };
    DeepLinkService.prototype.getSearchCriterias = function (searchCriterias, params) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var criteria, criteria;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!params.countyNumber) return [3 /*break*/, 1];
                        searchCriterias.push(this.getRouteCriteria(params));
                        return [3 /*break*/, 15];
                    case 1:
                        if (!params.corridorRt) return [3 /*break*/, 2];
                        searchCriterias.push(this.getCorridorRouteCriteria(params));
                        return [3 /*break*/, 15];
                    case 2:
                        if (!params.congressDistrictNumber) return [3 /*break*/, 3];
                        searchCriterias.push(this.getCongressDistrictCriteria(params));
                        return [3 /*break*/, 15];
                    case 3:
                        if (!params.houseDistrictNumber) return [3 /*break*/, 4];
                        searchCriterias.push(this.getHouseDistrictCriteria(params));
                        return [3 /*break*/, 15];
                    case 4:
                        if (!params.senateDistrictNumber) return [3 /*break*/, 5];
                        searchCriterias.push(this.getSenateDistrictCriteria(params));
                        return [3 /*break*/, 15];
                    case 5:
                        if (!(params.legislativeType === 'congress' || params.legislativeType === 'con')) return [3 /*break*/, 6];
                        searchCriterias.push({
                            type: 'congressDistrict',
                            congressDistrictNumber: parseInt(params.legislativeDistrict, 0)
                        });
                        return [3 /*break*/, 15];
                    case 6:
                        if (!(params.legislativeType === 'house' || params.legislativeType === 'hse')) return [3 /*break*/, 7];
                        searchCriterias.push({
                            type: 'houseDistrict',
                            houseDistrictNumber: parseInt(params.legislativeDistrict, 0)
                        });
                        return [3 /*break*/, 15];
                    case 7:
                        if (!(params.legislativeType === 'senate' || params.legislativeType === 'sen')) return [3 /*break*/, 8];
                        searchCriterias.push({
                            type: 'senateDistrict',
                            senateDistrictNumber: parseInt(params.legislativeDistrict, 0)
                        });
                        return [3 /*break*/, 15];
                    case 8:
                        if (!params.districtNumber) return [3 /*break*/, 9];
                        searchCriterias.push(this.getDistrictCriteria(params));
                        return [3 /*break*/, 15];
                    case 9:
                        if (!params.mpoRpo) return [3 /*break*/, 11];
                        return [4 /*yield*/, this.getPlanningPartnerCriteria(params)];
                    case 10:
                        criteria = _a.sent();
                        searchCriterias.push(criteria);
                        return [3 /*break*/, 15];
                    case 11:
                        if (!(params.countyNumber && params.municipalityId)) return [3 /*break*/, 12];
                        searchCriterias.push(this.getCountyMunicipalityCriteria(params));
                        return [3 /*break*/, 15];
                    case 12:
                        if (!params.municipalityId) return [3 /*break*/, 14];
                        return [4 /*yield*/, this.getMunicipalityCriteria(params)];
                    case 13:
                        criteria = _a.sent();
                        searchCriterias.push(criteria);
                        return [3 /*break*/, 15];
                    case 14:
                        if (params.countyMunicipalityCode) {
                            searchCriterias.push(this.getMunicipalityCodeCriteria(params));
                        }
                        else if (params.address) {
                            searchCriterias.push({
                                type: 'address',
                                address: params.address
                            });
                        }
                        else if (params.latitude && params.longitude) {
                            searchCriterias.push(this.getLatLongCriteria(params));
                        }
                        else if (params.layerId) {
                            searchCriterias.push(this.getLayerIdCriteria(params));
                        }
                        _a.label = 15;
                    case 15: return [2 /*return*/, searchCriterias];
                }
            });
        });
    };
    DeepLinkService.prototype.getCongressDistrictCriteria = function (params) {
        return {
            type: 'congressionalDistrict',
            congressionalDistrictNumber: parseInt(params.congressDistrictNumber, 0)
        };
    };
    DeepLinkService.prototype.getHouseDistrictCriteria = function (params) {
        return {
            type: 'houseDistrict',
            houseDistrictNumber: parseInt(params.houseDistrictNumber, 0)
        };
    };
    DeepLinkService.prototype.getSenateDistrictCriteria = function (params) {
        return {
            type: 'senateDistrict',
            senateDistrictNumber: parseInt(params.senateDistrictNumber, 0)
        };
    };
    DeepLinkService.prototype.getCountyMunicipalityCriteria = function (params) {
        return {
            type: 'municipality',
            countyCode: params.countyNumber,
            municipalityCode: params.municipalityId
        };
    };
    DeepLinkService.prototype.getRouteCriteria = function (params) {
        var searchCriteria;
        if (params.countyNumber && params.routeNumber) {
            searchCriteria = {
                type: 'route',
                countyCode: params.countyNumber,
                stateRouteNumber: params.routeNumber,
                isCorridor: params.corridorRt !== undefined
            };
            if (params.segmentNumberBegin) {
                searchCriteria.segBgn = params.segmentNumberBegin;
                if (params.segmentNumberEnd) {
                    searchCriteria.segEnd = params.segmentNumberEnd;
                }
            }
        }
        else if (params.countyNumber) {
            searchCriteria = {
                type: 'county',
                countyCode: params.countyNumber
            };
        }
        return searchCriteria;
    };
    DeepLinkService.prototype.getCorridorRouteCriteria = function (params) {
        var searchCriteria = {
            type: 'route',
            stateRouteNumber: params.corridorRt,
            isCorridor: true
        };
        if (params.segmentNumberBegin) {
            searchCriteria.segBgn = params.segmentNumberBegin;
            if (params.segmentNumberEnd) {
                searchCriteria.segEnd = params.segmentNumberEnd;
            }
        }
        return searchCriteria;
    };
    DeepLinkService.prototype.getPlanningPartnerCriteria = function (params) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_1, _a, planningPartners, planningPartners_1, planningPartners_1_1, partner;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.gisToolsService.getAllPlanningPartners('planningPartnerShortName')];
                    case 1:
                        planningPartners = _b.sent();
                        try {
                            //find the planning partner with the same value as the mpoRpo, and use its exact casing.
                            for (planningPartners_1 = tslib_1.__values(planningPartners), planningPartners_1_1 = planningPartners_1.next(); !planningPartners_1_1.done; planningPartners_1_1 = planningPartners_1.next()) {
                                partner = planningPartners_1_1.value;
                                if (partner.planningPartnerShortName.toLowerCase() === params.mpoRpo.toLowerCase()) {
                                    params.mpoRpo = partner.planningPartnerShortName;
                                }
                            }
                        }
                        catch (e_1_1) { e_1 = { error: e_1_1 }; }
                        finally {
                            try {
                                if (planningPartners_1_1 && !planningPartners_1_1.done && (_a = planningPartners_1.return)) _a.call(planningPartners_1);
                            }
                            finally { if (e_1) throw e_1.error; }
                        }
                        return [2 /*return*/, {
                                type: 'planningPartner',
                                planningPartnerShortName: params.mpoRpo
                            }];
                }
            });
        });
    };
    DeepLinkService.prototype.openMap = function (params) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var mapProps, mapId, mapProperties, map, maps, _a, _b, notification;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        mapProps = { id: params.mapId, counties: undefined, showLoadErrorMessage: true, showTitleInErrorMessage: false };
                        if (params.counties) {
                            mapProps.counties = params.counties;
                        }
                        mapId = parseInt(mapProps.id, 0);
                        mapProperties = 'id, extentJSON, name, uniqueName, description, data, isSystem, createdDate, lastEditedDate, isPublic, showOnAoi, basemap, layers{id, parentId, name}';
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.mapService.getMaps([mapId], mapProperties)];
                    case 2:
                        maps = _c.sent();
                        map = maps[0];
                        return [3 /*break*/, 4];
                    case 3:
                        _a = _c.sent();
                        console.error('Can\'t load map');
                        this.mapService.clearLoading();
                        return [3 /*break*/, 4];
                    case 4:
                        if (!(!map.isPublic && !map.isSystem)) return [3 /*break*/, 8];
                        _c.label = 5;
                    case 5:
                        _c.trys.push([5, 7, , 8]);
                        return [4 /*yield*/, this.mapService.getMaps([mapId], 'userMaps { accessLevel }')];
                    case 6:
                        _c.sent();
                        return [3 /*break*/, 8];
                    case 7:
                        _b = _c.sent();
                        this.mapService.clearLoading();
                        notification = {
                            message: 'You are not authorized to view this map.',
                            level: LogLevel.Error,
                            isPrivate: false
                        };
                        if (!this.isUserLoggedIn) {
                            notification.message = 'This map requires an authorized user to view. Logging in may allow the map to be viewed.';
                        }
                        window.dispatchEvent(new CustomEvent('notAuthorized', { detail: notification, composed: true }));
                        return [2 /*return*/];
                    case 8: return [4 /*yield*/, this.mapService.openMap(map)];
                    case 9:
                        _c.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    DeepLinkService.prototype.getDistrictCriteria = function (params) {
        var districtNumber = parseInt(params.districtNumber, 0);
        var num = 10;
        var result = (districtNumber < num) ? '0' + districtNumber.toString() : districtNumber.toString();
        return {
            type: 'district',
            districtNumber: result
        };
    };
    DeepLinkService.prototype.getMunicipalityCriteria = function (params) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var municipalities, muni;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.gisToolsService.getAllMunicipalities('id,county,municipal_code')];
                    case 1:
                        municipalities = _a.sent();
                        muni = municipalities.find(function (m) { return m.id === params.municipalityId; });
                        return [2 /*return*/, {
                                type: 'municipality',
                                countyCode: muni.county,
                                municipalityCode: muni.municipalityId
                            }];
                }
            });
        });
    };
    DeepLinkService.prototype.getMunicipalityCodeCriteria = function (params) {
        var cntyLength = 2;
        var muniLength = 3;
        var countyCode = params.countyMunicipalityCode.substr(0, cntyLength);
        var muniCode = params.countyMunicipalityCode.substr(cntyLength, muniLength);
        return {
            type: 'municipality',
            countyCode: countyCode,
            municipalityCode: muniCode
        };
    };
    DeepLinkService.prototype.formatAssetIdCriteria = function (assetIdSearchCriteria) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var options;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        assetIdSearchCriteria.columnName = AssetIdColumnMap[assetIdSearchCriteria.assetIdType];
                        return [4 /*yield*/, this.searchApi.getAoiAssetIdOptions(assetIdSearchCriteria.columnName, 'layerId, displayName')];
                    case 1:
                        options = _a.sent();
                        assetIdSearchCriteria.layerId = options.aoiAssetIdOptions[0].layerId;
                        assetIdSearchCriteria.title = options.aoiAssetIdOptions[0].displayName + ": " + assetIdSearchCriteria.data;
                        return [2 /*return*/, assetIdSearchCriteria];
                }
            });
        });
    };
    DeepLinkService.prototype.showBySearchCriterias = function (searchCriterias, params) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.authorizeLayers(searchCriterias)];
                    case 1:
                        if (!(_a.sent())) {
                            return [2 /*return*/];
                        }
                        this.AOIService.setSearchCriterias(searchCriterias);
                        if (!(params.mapId && params.mapId !== 'undefined')) return [3 /*break*/, 4];
                        params.mapId = parseInt(params.mapId, 0);
                        if (!isNaN(params.mapId)) return [3 /*break*/, 2];
                        params.mapId = 'default';
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this.AOIService.setSelectedMapId(params.mapId)];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4: return [4 /*yield*/, this.AOIService.showBySearchCriteriasAndMap()];
                    case 5:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    DeepLinkService.prototype.authorizeLayers = function (searchCriterias) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_2, _a, layerIds, result, layerPermissions, message, _loop_1, this_1, _b, _c, layerId, state_1, detail;
            return tslib_1.__generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        layerIds = searchCriterias.filter(function (sc) { return sc.layerId != null; }).map(function (sc) { return sc.layerId; });
                        return [4 /*yield*/, this.layerApi.getLayerPermissions(layerIds)];
                    case 1:
                        result = _d.sent();
                        layerPermissions = {};
                        if (layerIds.length) {
                            layerIds.forEach(function (layerId) { return layerPermissions[layerId] = []; });
                            result.forEach(function (lp) { return layerPermissions[lp.layerId].push(lp.name); });
                            _loop_1 = function (layerId) {
                                var permissions = layerPermissions[layerId];
                                if (permissions.includes('MapCore Public Layers')) {
                                    return "continue";
                                }
                                if (!this_1.userPermissions.some(function (up) { return permissions.includes(up); })) {
                                    message = layerIds.length === 1
                                        ? 'This layer requires an authorized user to view.'
                                        : 'One or more layers require an authorized user to view.';
                                    if (!this_1.isUserLoggedIn) {
                                        message += ' Logging in may allow the layer to be viewed.';
                                    }
                                    return "break";
                                }
                            };
                            this_1 = this;
                            try {
                                for (_b = tslib_1.__values(Object.keys(layerPermissions)), _c = _b.next(); !_c.done; _c = _b.next()) {
                                    layerId = _c.value;
                                    state_1 = _loop_1(layerId);
                                    if (state_1 === "break")
                                        break;
                                }
                            }
                            catch (e_2_1) { e_2 = { error: e_2_1 }; }
                            finally {
                                try {
                                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                                }
                                finally { if (e_2) throw e_2.error; }
                            }
                        }
                        if (message) {
                            detail = { message: message, level: LogLevel.Error, isPrivate: false };
                            window.dispatchEvent(new CustomEvent('notAuthorized', { detail: detail, composed: true }));
                            return [2 /*return*/, false];
                        }
                        else {
                            return [2 /*return*/, true];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    DeepLinkService.prototype.getAssetIdSearchCriteria = function (params) {
        var criteria = null;
        AssetIdTypes.forEach(function (item) {
            if (params[item]) {
                if (!criteria) {
                    criteria = {};
                }
                criteria = {
                    type: 'assetId',
                    data: params[item],
                    ids: params[item].split(','),
                    assetIdType: item
                };
            }
        });
        return criteria;
    };
    DeepLinkService.prototype.getLatLongCriteria = function (params) {
        return {
            type: 'latLong',
            latitude: params.latitude,
            longitude: params.longitude
        };
    };
    DeepLinkService.prototype.getLayerIdCriteria = function (params) {
        var searchCriteria = {
            type: 'assetId',
            layerId: parseInt(params.layerId, 10),
            displayName: params.column,
            columnName: params.column,
            data: params.value
        };
        if (params.query) {
            params.query = decodeURIComponent(params.query);
            searchCriteria.query = JSON.parse(params.query);
        }
        return searchCriteria;
    };
    DeepLinkService.ngInjectableDef = i0.defineInjectable({ factory: function DeepLinkService_Factory() { return new DeepLinkService(i0.inject("authenticationService"), i0.inject(i1.DeepLinkProcessor), i0.inject(i2.MapService), i0.inject(i3.AoiService), i0.inject(i4.GisToolsService), i0.inject(i5.QueryStringParamService), i0.inject(i6.SearchApi), i0.inject(i7.LayerApi)); }, token: DeepLinkService, providedIn: "root" });
    return DeepLinkService;
}());
export { DeepLinkService };
